import { useState, useEffect } from 'react';

// A hook to tell whether the current browser tab is in focus. Forces a re-render when the focus state changes.
export function useIsBrowserTabInFocus() {
  const [isWindowInFocus, setIsWindowInFocus] = useState(document.visibilityState === 'visible');

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsWindowInFocus(document.visibilityState === 'visible');
    };
    window.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return isWindowInFocus;
}
